var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"type":"text","name":"single"}})
}
var staticRenderFns = []

export { render, staticRenderFns }